import * as React from "react";
import { cn } from "@/lib/utils";

/** Navy (brand-900) summary block — large value + stat chips. Used on Home and Project detail. */
export const SummaryCard = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <section
      ref={ref}
      className={cn("bg-brand-900 px-5 pb-5 pt-3 text-white shadow-md", className)}
      {...props}
    />
  ),
);
SummaryCard.displayName = "SummaryCard";

/** Translucent stat tile used inside SummaryCard. */
export const SummaryStat: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...props
}) => (
  <div
    className={cn("rounded-xl border border-white/15 bg-white/10 p-2.5", className)}
    {...props}
  />
);

export default SummaryCard;
